import React from 'react';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';
import RightIcon from '@/assets/PaymentDlg/right.svg';
import SmallRightIcon from '@/assets/PaymentDlg/smallright.svg';

const RoleList = ({ small = false }) => {
  const { isEdu } = store.userStore;
  const role1 = intl.formatMessage({ id: 'account.Role1' });
  const role2 = intl.formatMessage({ id: 'account.Role2' });
  const role3 = intl.formatMessage({ id: 'account.Role3' });
  const role4 = intl.formatMessage({ id: 'account.Role4' });
  const role5 = intl.formatMessage({ id: 'account.Role5' });
  const list = isEdu ? [role1, role2, role3, role5] : [role1, role2, role3, role4];
  return (<dl className={`role-list ${small ? 'small' : ''}`}>
    {list.map((item, index) => (<dd key={`role_${index}`}><img src={small ? SmallRightIcon : RightIcon} alt={item} />
      <span>{item}</span>
    </dd>))}
  </dl>);
};
export default RoleList;